<template>
  <v-container
    style="height: 100%"
    class="pa-0 ma-0 container d-flex align-start flex-column"
  >
    <AlertStatus />
    <div
      style="overflow-y: scroll; width: 100%"
      :style="{ height: systemMessage ? 'calc(100% - 130px)' : '100%' }"
    >
      <v-list width="100%" color="#2c3e50">
        <v-list-item v-for="(item, i) in alerts" :key="i" class="px-2 pb-1">
          <v-card
            tile
            class="alert-card"
            @click="showAlert(item)"
            color="rgba(255,255,255,0.1)"
          >
            <v-card-text class="pa-2 white--text">
              <v-chip x-small dark :color="item.color" v-if="item.heading">
                {{ item.heading }}
              </v-chip>
              <div class="mt-1 body-2">
                {{ item.title }}
              </div>
              <div v-if="isAreaVisible" class="alert-area overline">
                {{ item.area }}
              </div>
              <div class="text-right">
                <span class="caption font-weight-light">
                  {{ item.date }}
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-list-item>
      </v-list>
    </div>
    <v-card
      class="mx-2 mt-4 pa-1 white--text"
      height="110"
      width="305"
      color="rgba(255,255,255,0.1)"
      v-if="systemMessage"
    >
      <h5>お知らせ</h5>
      <div class="system-message" v-html="systemMessage"></div>
    </v-card>
    <v-dialog v-model="dialog" scrollable width="600">
      <v-card color="white">
        <v-card-title class="headline">{{ target.title }}</v-card-title>
        <v-card-text class="alert-content">{{ target.content }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="dialog = false">
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { alertConfig } from "../config";
import AlertStatus from "./AlertStatus";
import { isPrivateMode } from "../utils/common";
export default {
  name: "AlertInformation",
  components: {
    AlertStatus
  },
  data() {
    return {
      sysMsg: null,
      target: {
        title: "",
        content: ""
      },
      dialog: false,
      isAreaVisible: alertConfig.Cities.length >= 2
    };
  },
  computed: {
    alerts() {
      return this.$store.getters.alerts;
    },
    systemMessage() {
      const text = this.$store.getters.systemMessage;
      const urlRegex = /https?:\/\/[^\s]+/g;
      return text.replace(urlRegex, url => {
        return `<a href="${url}" target="_blank" style="color: white">${url}</a>`;
      });
    }
  },
  created() {
    this.loadSystemMessage();
  },
  methods: {
    showAlert(alert) {
      this.target.title = alert.title;
      let content = "";
      if (alert.text) {
        content = alert.text;
      }
      if (alert.comment) {
        if (content !== "") {
          content += "\n\n";
        }
        content += alert.comment;
      }
      this.target.content = content;
      this.dialog = true;
    },
    async loadSystemMessage() {
      const url =
        "https://s3.ap-northeast-1.amazonaws.com/ctie.tamura.web/system/messages.json";
      const response = await axios.get(url).catch(null);
      if (response && response.data) {
        const targetField = isPrivateMode ? "private" : "public";
        this.$store.commit("SET_SYSTEM_MESSAGE", response.data[targetField]);
      } else {
        this.$store.commit("SET_SYSTEM_MESSAGE", "");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.alert-card {
  width: 100%;
  .alert-area {
    opacity: 0.8;
    line-height: 1rem;
    font-size: 0.625rem !important;
  }
}
.alert-content {
  white-space: pre-line;
}
.system-message {
  height: 80px;
  overflow-y: scroll;
  white-space: pre-wrap;
  word-break: break-all;
  font-size: 12px;
}
</style>
